

export const ErrorSnackClose = () => ({
  type: "ERROR_SNACK_CLOSE",
});

export const ErrorSnacktOpen = (mensaje, errorObject) => ({
  type: "ERROR_SNACK_OPEN",
  mensaje,
  errorObject,
});



// WEBPACK FOOTER //
// ./src/components/ErrorSnack/actions.js